(function() {
    'use strict';

    angular
        .module('app')
        .directive('drvWorkflowInstanceList', drvWorkflowInstanceList);

    drvWorkflowInstanceList.$inject = [];
    
    /**
     * Directive for loading, displaying and modifying workflow instances in a list display
     *
     * # Scope Properties
     * {int} workflowId - Used to filter workflow instances for a specific workflow definition
     */
    function drvWorkflowInstanceList() {
        var directive = {
            restrict: 'EA',
            scope: {},
            controller: WorkflowInstanceListCtrl,
            controllerAs: 'vm',
            bindToController: {
                workflowId: '<'
            },
            templateUrl: 'app/workflow/workflow-instance-list.tmpl.html'
        };
        return directive;
    }

    WorkflowInstanceListCtrl.$inject = [
        '$q',
        'WorkflowService',
        'WorkflowInstanceDataService',
        'SystemService',
        'DialogService',
        'NavigationAidService',
        'WindowTitleService'];

    function WorkflowInstanceListCtrl(
        $q,
        WorkflowService,
        WorkflowInstanceDataService,
        SystemService,
        DialogService,
        NavigationAidService,
        WindowTitleService) {
        /* jshint validthis:true */
        var vm = this;
        vm.loading = true;
        vm.workflowInstances = [];
        vm.workflowInstancesListPage = 1;
        vm.workflowInstancesCount = 0;
        vm.workflowInstancesError = null;
        vm.formatDate = formatDate;
        vm.close = close;
        vm.updateList = loadWorkflowInstances;
        Object.defineProperty(vm, 'viewTitle', { get: function () { return 'History - ' + ((!_.isNil(vm.workflowDefinition) && !_.isNil(vm.workflowDefinition.Name)) ? vm.workflowDefinition.Name : ''); } });

        activate();

        function activate() {
            var loadPromises = [];
            loadPromises.push(loadListPageSize());
            loadPromises.push(loadWorkflowDefinition());

            $q.all(loadPromises)
                .then(function () {
                    WindowTitleService.setTitle(vm.viewTitle);
                    loadWorkflowInstances();
                });
        }

        /**
         * Load the page size used for the workflow instance list
         */
        function loadListPageSize() {
            return SystemService.getMenuListSize('Workflow Instances')
                .then(getListPageSizeOk, getListPageSizeError);

            function getListPageSizeOk(data) {
                vm.workflowInstancesListPageSize = data;
            }

            function getListPageSizeError(response) {
                DialogService.error('Error fetching list size', response);
            }
        }

        /**
         * Load the workflow definition for which the instances belong. This is used to populate the view title.
         */
        function loadWorkflowDefinition() {
            return WorkflowService.get(vm.workflowId).then(getWorkflowOk, getWorkflowError);

            function getWorkflowOk(workflow) {
                vm.workflowDefinition = workflow;
            }

            function getWorkflowError(response) {
                if (response.status === 404) {
                    vm.notFound = true;
                } else {
                    DialogService.error('Error fetching Workflow', response);
                }
            }
        }

        /**
         * Load the workflow instances. Result will be displayed in the workflow instance list.
         */
        function loadWorkflowInstances() {
            if (loadWorkflowInstances.currentPromise === undefined) {
                loadWorkflowInstances.currentPromise = null;
            }
            vm.loading = true;

            var getPromise = WorkflowInstanceDataService.query({
                pageSize: vm.workflowInstancesListPageSize,
                currentPage: vm.workflowInstancesListPage,
                workflowId: vm.workflowId
            })
                .then(loadWorkflowInstancesOk, loadWorkflowInstancesError)
                .then(function () {
                    vm.loading = false;
                });

            loadWorkflowInstances.currentPromise = getPromise;

            return getPromise;

            function loadWorkflowInstancesOk(data) {
                if (getPromise === loadWorkflowInstances.currentPromise) {
                    vm.workflowInstances = data.Items;
                    vm.workflowInstancesCount = data.ItemCount;
                }
                else {
                    return $q.reject();
                }
            }

            function loadWorkflowInstancesError(response) {
                if (getPromise === loadWorkflowInstances.currentPromise) {
                    vm.workflowInstancesError = response;
                }
                else {
                    return $q.reject();
                }
            }
        }

        /*
         * Formats the supplied date so it's user readable
         *
         * @param {string} date - Date to be formatted
         *
         * @returns {string} - Returns the data in user readable format
         */
        function formatDate(date) {
            return SystemService.getFormattedDate(date);
        }

        /**
         * When the view is 'closed' navigation to a previous page should occur.
         */
        function close() {
            NavigationAidService.goBack();
        }
    }
})();